import axiosInstance from './axiosConfig';

const purchaseOrderAPI = {
  getAll: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/purchase-order', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch purchase orders';
    }
  },

  getById: async (id) => {
    try {
      const response = await axiosInstance.get(`/purchase-order/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch purchase order';
    }
  },

    // Get PO items
    getItems: async (poId) => {
        try {
            const response = await axiosInstance.get(`/purchase-order/${poId}/items`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Failed to fetch PO items';
        }
    },

    receiveItem: async (poId, itemId, quantity) => {
        try {
          const response = await axiosInstance.put(
            `/purchase-order/${poId}/items/${itemId}/receive`,
            { quantity },
            { timeout: 5000 } // Add timeout
          );
          return response.data;
        } catch (error) {
          if (error.response) {
            // Server responded with error status
            throw new Error(error.response.data.message || "Failed to update item");
          } else if (error.request) {
            // No response received
            throw new Error("No response from server. Please try again.");
          } else {
            // Other errors
            throw new Error(error.message);
          }
        }
      },

  create: async (poData) => {
    try {
      const response = await axiosInstance.post('/purchase-order', poData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to create purchase order';
    }
  },

  update: async (id, poData) => {
    try {
      const response = await axiosInstance.put(`/purchase-order/${id}`, poData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update purchase order';
    }
  },

  cancel: async (id) => {
    try {
      const response = await axiosInstance.put(`/purchase-order/${id}/cancel`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to cancel purchase order';
    }
  },

  receive: async (id, receiveData) => {
    try {
      const response = await axiosInstance.put(`/purchase-order/${id}/receive`, receiveData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to mark as received';
    }
  },

  // Additional purchase order-specific methods
  getByStatus: async (status) => {
    try {
      const response = await axiosInstance.get(`/purchase-order/status/${status}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || `Failed to fetch ${status} purchase orders`;
    }
  },

  getBySupplier: async (supplierId) => {
    try {
      const response = await axiosInstance.get(`/purchase-order/supplier/${supplierId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch supplier purchase orders';
    }
  },

  generatePoNumber: async () => {
    try {
      const response = await axiosInstance.get('/purchase-order/generate-po-number');
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to generate PO number';
    }
  },

  updateDate: async (id, orderDate) => {
    try {
      const response = await axiosInstance.put(`/purchase-order/${id}/date`,  orderDate );
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update purchase order date';
    }
  },

  returnItems: async (id, returnData) => {
    try {
      const response = await axiosInstance.post(`/purchase-order/${id}/return`, returnData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to process return';
    }
  },

  getReturns: async (id) => {
    try {
      const response = await axiosInstance.get(`/purchase-order/${id}/returns`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch return history';
    }
  },

  getReturnOrders: async (id) => {
    try {
      const response = await axiosInstance.get(`/purchase-order/${id}/returns`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch return orders';
    }
  }

};

export default purchaseOrderAPI;